var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConfi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_398_78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5 0C32.9207 0 37.1042 1.00714 40.8423 2.80352C39.3122 4.01402 37.8935 5.1761 36.5716 6.2946C34.0538 5.37946 31.3374 4.88073 28.5048 4.88073C21.9827 4.88073 16.0754 7.52447 11.8048 11.8C7.52931 16.0754 4.88558 21.9778 4.88558 28.5C4.88558 35.0222 7.52931 40.9246 11.8048 45.2001C16.0803 49.4755 21.9827 52.1193 28.5048 52.1193C35.027 52.1193 40.9342 49.4755 45.2049 45.2001C49.4804 40.9246 52.1241 35.0222 52.1241 28.5C52.1241 26.9506 51.974 25.4302 51.6883 23.9631C52.9134 22.3652 54.1674 20.7722 55.4506 19.1937C56.4577 22.1086 57.0048 25.2413 57.0048 28.5C57.0048 36.3682 53.814 43.4957 48.6572 48.6524C43.5005 53.8091 36.3731 57 28.5048 57C20.6366 57 13.5092 53.8091 8.35245 48.6524C3.19088 43.4957 0 36.3682 0 28.5C0 20.6318 3.19088 13.5043 8.3476 8.3476C13.5043 3.19088 20.6318 0 28.5 0ZM15.2232 23.8178L22.1763 23.7258L22.6944 23.8614C24.0986 24.67 25.4205 25.5948 26.6552 26.6407C27.5461 27.396 28.3983 28.2192 29.2069 29.1101C31.7006 25.0961 34.3588 21.4113 37.1672 18.0219C40.2418 14.3081 43.5054 10.9381 46.9335 7.86341L47.6114 7.60194H55.1988L53.6687 9.30148C48.9671 14.526 44.7013 19.9248 40.8471 25.4931C36.9929 31.0663 33.5454 36.8186 30.4804 42.7403L29.5265 44.5803L28.6501 42.7064C27.0329 39.2347 25.0961 36.0487 22.7864 33.2016C20.4768 30.3545 17.7895 27.827 14.6567 25.6771L15.2232 23.8178Z",
    fill: "#5ED5A8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_398_78",
    x: -16,
    y: -11,
    width: 89.0049,
    height: 89,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.368627 0 0 0 0 0.835294 0 0 0 0 0.658824 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_398_78"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_398_78",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfi);
export default __webpack_public_path__ + "static/media/confi.ff61179bba7e16edf3bd9258afcdbb7d.svg";
export { ForwardRef as ReactComponent };